<template lang="html">
  <v-switch
    class="ftBooleanSwitch"
    :class="{ ftWarningSwitch : warning, 'pt-3': displayInline }"
    :label="label"
    :hint="hint"
    :color="warning ? 'warning' : $ftStyle.switch"
    :error-messages="errorMessages"
    :disabled="disabled"
    :input-value="switchVal"
    :hide-details="hideDetails"
    :persistent-hint="persistentHint"
    @change="setBoolean"
  />
</template>

<script>
export default {
  name: 'VBoolean',
  props: {
    label: String,
    hint: String,
    value: Boolean,
    required: Boolean,
    warning: Boolean,
    disabled: Boolean,
    inline: Boolean,
    autoInline: Boolean,
    hideDetails: Boolean,
    persistentHint: Boolean,
    errorMessages: {
      type: Array,
      default () {
        const val = []
        val._clear = () => {}
        return val
      }
    },
    invert: Boolean
  },
  data () {
    return {
      switchVal: null
    }
  },
  computed: {
    displayInline () {
      return this.inline || this.autoInline && !this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    value (val) {
      const newVal = this.getVal(val)
      if (newVal !== this.switchVal) {
        this.switchVal = newVal
      }
    }
  },
  mounted () {
    this.switchVal = this.getVal(this.value)
  },
  methods: {
    setBoolean (val) {
      if (val !== this.switchVal) {
        this.switchVal = val
        this.$emit('input', this.getVal(val))
        this.errorMessages._clear()
      }
    },
    getVal (val) {
      return this.invert ? !val : !!val
    }
  }
}
</script>
<style>
/*
  .ftBooleanSwitch {
    display: inline-block !important;
    width: auto !important;
  }
  */
  .ftBooleanSwitch label {
    overflow: visible !important;
  }
  .ftWarningSwitch label {
    color: inherit !important;
  }
</style>
